import { render, staticRenderFns } from "./xmFujian.vue?vue&type=template&id=03e05620&scoped=true"
import script from "./xmFujian.vue?vue&type=script&lang=js"
export * from "./xmFujian.vue?vue&type=script&lang=js"
import style0 from "./xmFujian.vue?vue&type=style&index=0&id=03e05620&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e05620",
  null
  
)

export default component.exports